// apiErrorHandler.js
// atualização 19/10/24 | 21h02 | eliminado código redundante para melhor uso em conjunto com "apiaxios.js";



import Swal from 'sweetalert2';

const showSwalError = (icon, title, text) => {
    Swal.fire({
        icon,
        title,
        text,
        timer: 3000,
        timerProgressBar: true
    });
};

const handleApiError = (error) => {
    if (error.response) {
        const { status, data } = error.response;
        // console.log('erro inesperado :', error);
        // const message = data.retorno || data.message || 'Ocorreu um erro inesperado.';
        const message = data.retorno || data.message || 'Seção expirada. Faça login novamente.';

        switch (status) {
            case 400:
                showSwalError('error', 'Atenção', message || 'Requisição inválida.');
                break;
            case 401:
                showSwalError('error', 'Não Autorizado', message || 'Você não tem permissão para acessar este recurso.');
                break;
            case 403:
                showSwalError('error', 'Proibido', message || 'Acesso negado.');
                break;
            case 404:
                showSwalError('warning', 'Não Encontrado', message || 'O recurso solicitado não foi encontrado.');
                break;
            case 500:
                showSwalError('error', 'Erro no Servidor', message || 'Ocorreu um erro interno no servidor.');
                break;
            default:
                showSwalError('error', 'Erro', message || 'Ocorreu um erro inesperado.');
                break;
        }
    } else {
        // Erro de rede ou outra falha
        showSwalError('error', 'Erro de Conexão', 'Não foi possível conectar ao servidor. Por favor, verifique sua conexão com a internet.');
    }
};

export default handleApiError;